import Image from "next/image";
import LikeComment from "./likeComment";
import { ISingleReplyProps } from "interfaces";
import { getRemainingTime } from "helpers";
import dynamic from "next/dynamic";

const EmptyProfileIcon = dynamic(() => import("../../icon-components/emptyProfile"));

const SingleReply = ({ reply, usersRepliesProfiles, commentsLocalStorageIds }: ISingleReplyProps) => {

    const user = usersRepliesProfiles.find((user:any) => user.id === reply.author);

    return (
        <div className="pl-w-full pl-pr-4 pl-pt-4">
            <div className="pl-flex pl-justify-between pl-items-center pl-w-full">
                <div className="pl-flex pl-items-center pl-gap-1 pl-text-[11px] pl-font-normal">
                    {user && Object.keys(user.profile).length > 0 && user.profile.avatar_url ? <Image src={user.profile.avatar_url} width={24} height={24} alt="user-profile" className="pl-rounded-full" /> : <EmptyProfileIcon />}
                    <p className="pl-text-main-highLight">{user && Object.keys(user.profile).length > 0 && user.profile.name ? user.profile.name : "کاربر ناشناس"} .</p>
                    <span className="pl-text-z-gray-400">{getRemainingTime(reply.created_at)}</span>
                </div>
                <LikeComment commentId={reply.id} likesCount={reply.like} isIdInLocalStorage={!!commentsLocalStorageIds && commentsLocalStorageIds.includes(reply.id)}/>
            </div>
            <p className="pl-text-[13px] pl-font-normal pl-leading-[22px] pl-mb-1 pl-text-z-gray-700 dark:pl-text-secondary-50">{reply.text}</p>
        </div>
    )
}

export default SingleReply;